import { DataSourceFormat } from '@/resources/enum';
import { ShapeBaseAttribute } from './base';

export interface TextString {
  // 是否为数据源
  isSource?: boolean;
  // text值或数据源
  value: string;
  color?: string;
  sourceFormat?: DataSourceFormat;
  renderingValue?: string;
}

export class TextAttribute extends ShapeBaseAttribute {
  fontId?: string;
  fontSize = 20;
  fontWeight?: string;
  /**
   * 文本颜色
   */
  color = '#ffffff';
  /**
   * 文本样式
   */
  style: 'normal' | 'arc' = 'normal';
  /**
   * 文本水平对齐
   */
  align: 'left' | 'center' | 'right' = 'left';

  letterSpace = 0;
  rotation = 0;
  /**
   * 圆弧半径
   */
  radius = 50;
  /**
   * 圆弧起始角度
   */
  startAngle = 0;

  /**
   * 文本内容
   */
  text = '文本';

  /**
   * 弧形文本扫描范围
   */
  arcSpan = 45;

  /**
   * 文本内容
   */
  strings: TextString[] = [{ value: '文本', color: '#ffffff' }];

  /**
   * 宽度是否自适应
   */
  sizeContent = true;

  resources: {
    /**
     * ifttt无数据时显示的图片
     */
    iftttEmptyImage?: LayerResourceItem;
  } = {};

  /**
   *是否反转文本方向
   */
  reverseText = false;

  /*
   * 数据源格式
   */
  sourceFormat?: DataSourceFormat = 1;

  /**
   * 弧形文本：文本位置
   * 仅arc文本样式时有效，0:(默认)文字在圆外部，1:文字中心在圆上，2:文字在圆内部
   * 注意这里和协议里面反了，在导出的时候处理一下即可
   * @type {('top' | 'center' | 'under')}
   * @memberof TextAttribute
   */
  verticalAlign?: 'top' | 'center' | 'under';
  verticalAlignReversed?: boolean;

  longMode?: 'wrap' | 'dot' | 'clip' = 'dot';
}
